<template>
    <basic-container>
        <el-form label-width="100px" inline>
          <el-form-item label="项目名称" required valid="projectId">
            <el-select v-model="addInspectPlanForm.projectId" validname="项目名称" @change="handleProjectIdChange">
              <el-option
                  v-for="(item,index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划名称" required valid="name">
            <el-input v-model="addInspectPlanForm.name" maxlength="8"></el-input>
          </el-form-item>
          <el-form-item label="计划日期" required valid="dateRange">
              <el-date-picker
                v-model="addInspectPlanForm.dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="计划类型">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="巡检班组">
            <el-input></el-input>
          </el-form-item> -->
        </el-form>
        <el-form label-width="100px" inline>
            <!-- <el-form-item label="巡检班组" valid="groupId">
              <el-select v-model="addInspectPlanForm.groupId" validname="班组名称" @change="handleProjectIdChange">
                <el-option
                    v-for="(item,index) in groupLidt"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="巡检人" valid="handerId">
              <avue-input-tree  v-model="addInspectPlanForm.planInspectManId" placeholder="请选择巡检人"  :dic="handleIdList"></avue-input-tree>
              <!-- <el-select v-model="addInspectPlanForm.planInspectManId" validname="巡检人" @change="planInspectManIdChange">
                <el-option
                    v-for="item in handleIdList"
                    :key="item"
                    :label="item.realName"
                    :value="item.userId"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
        </el-form>
        <el-form label-width="100px" >
          
          <el-form-item label="巡检周期" valid="inspectCycleType">
            <el-radio-group v-model="addInspectPlanForm.inspectCycleType" @change="handleCycleTypeChange">
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">周</el-radio>
              <el-radio :label="3">月</el-radio>
              <el-radio :label="4">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="具体时间" required v-if="addInspectPlanForm.inspectCycleType==2" valid="detailDateList">
            <div v-if="addInspectPlanForm.inspectCycleType==2">
              <el-checkbox-group v-model="addInspectPlanForm.detailDateList">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="具体时间" required v-if="addInspectPlanForm.inspectCycleType==3" valid="detailDateList">
            <div v-if="addInspectPlanForm.inspectCycleType==3">
              <el-checkbox-group v-model="addInspectPlanForm.detailDateList">
                <el-checkbox label="1"></el-checkbox>
                <el-checkbox label="2"></el-checkbox>
                <el-checkbox label="3"></el-checkbox>
                <el-checkbox label="4"></el-checkbox>
                <el-checkbox label="5"></el-checkbox>
                <el-checkbox label="6"></el-checkbox>
                <el-checkbox label="7"></el-checkbox>
                <el-checkbox label="8"></el-checkbox>
                <el-checkbox label="9"></el-checkbox>
                <el-checkbox label="10"></el-checkbox>
                <el-checkbox label="11"></el-checkbox>
                <el-checkbox label="12"></el-checkbox>
                <el-checkbox label="13"></el-checkbox>
                <el-checkbox label="14"></el-checkbox>
                <el-checkbox label="15"></el-checkbox>
                <el-checkbox label="16"></el-checkbox>
                <el-checkbox label="17"></el-checkbox>
                <el-checkbox label="18"></el-checkbox>
                <el-checkbox label="19"></el-checkbox>
                <el-checkbox label="20"></el-checkbox>
                <el-checkbox label="21"></el-checkbox>
                <el-checkbox label="22"></el-checkbox>
                <el-checkbox label="23"></el-checkbox>
                <el-checkbox label="24"></el-checkbox>
                <el-checkbox label="25"></el-checkbox>
                <el-checkbox label="26"></el-checkbox>
                <el-checkbox label="27"></el-checkbox>
                <el-checkbox label="28"></el-checkbox>
                <el-checkbox label="29"></el-checkbox>
                <el-checkbox label="30"></el-checkbox>
                <el-checkbox label="31"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="巡视开始时间" required v-if="addInspectPlanForm.inspectCycleType==4" valid="inspectBeginTime">

            
          <el-date-picker
            v-model="addInspectPlanForm.inspectBeginTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
            <!-- <el-input v-model="addForm.inspectBeginTime"></el-input> -->
          </el-form-item>
          <el-form-item label="巡检天数" required v-if="addInspectPlanForm.inspectCycleType==4" valid="inspectCycle">
            <el-input v-model="addInspectPlanForm.inspectCycle" maxlength="4"></el-input>
          </el-form-item>
          <el-form-item label="周期休息天数（天）" required v-if="addInspectPlanForm.inspectCycleType==4" valid="intervalTime">
            <el-input v-model="addInspectPlanForm.intervalTime" maxlength="4"></el-input>
          </el-form-item>
              <!-- v-show="inspectplanAddForm.groupId" -->
          <el-form-item label="时间段" required valid="timeQuantum">
            
            <select-time
            v-if="selectTimeFlag"
            v-model="addInspectPlanForm.timeQuantum"
              :selectedTime="selectedTime"
              @getTime="getTime"
              ref="selectTimeAdd"
            >
            </select-time>
          </el-form-item>
          
        </el-form>
        <el-form label-width="100px">
          <el-form-item label="巡检说明" required valid="remark">
            <el-input v-model="addInspectPlanForm.remark" type="textarea" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="巡检路线" required valid="dateRange">
            <div>
              <div>
                <el-button 
                type="primary"
                   size="small"
                   icon="el-icon-plus"
                   @click="addInspectLine"
                >
                  新增
                </el-button>
              </div>
              <el-table :data="inspectLineList">
                <el-table-column
                    label="排序"
                    type="index"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="deviceName"
                    label="设备名称"
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    prop="remark"
                    label="位置"
                  >
                  </el-table-column> -->
                  <el-table-column
                    prop="standardNames"
                    label="巡检标准"
                  >
                  </el-table-column>
                  <el-table-column
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <!-- <el-button type="text" @click="editHandler(scope.row)">编辑</el-button> -->
                      <el-button type="text" @click="deleteHandler(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item>
          </el-form-item>
        </el-form>
    <el-dialog
        title="新增巡检路线"
        :visible.sync="dialogInspectLineCreateBoxVisible"
        append-to-body>
        <el-form label-width="100px" v-if="dialogInspectLineCreateBoxVisible">
          <el-form-item label="设备名称" required>
            <el-select 
              filterable
              v-model="inspectForm.deviceId"
              @change="handleDeviceChange"
            >
              <el-option
                  v-for="(item,index) in deviceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >
<span style="float: left">{{ item.code?item.name+'-'+item.code:item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.areaName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="位置">
standardList
          </el-form-item> -->
          <el-form-item label="巡检标准" required>
                <el-select 
                v-model="inspectForm.standardIds"
                @change="handleStandardChange"
                multiple
                >
                    <el-option
                        v-for="(item,index) in standardList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    >

                    </el-option>
                </el-select>
          </el-form-item>
          <el-form-item>
                      <el-button type="primary" @click="saveInspectLineHandler">保存</el-button>
                      <el-button @click="dialogInspectLineCreateBoxVisible=false">取消</el-button>
          </el-form-item>       
        </el-form>
    </el-dialog>
    <!-- <div style="position:absolute;bottom:0;left:0;width:100%;text-align:center;padding-bottom: 2rem;"> -->
    <div style="width:100%;text-align:center;padding-bottom: 2rem;">
        <el-button type="primary" @click="submitInspectAddFrom">
            提交
        </el-button>
        <el-button @click="cancelInspectAddFrom">
            取消
        </el-button>
    </div>
      </basic-container>
</template>

<script>
  import selectTime from "./select-time";
  import {getDeviceList, getStandardList, saveInspectPlan} from "@/api/crmedical/device/deviceinspectplan";
  import {getProjectList,getGroupListByModuleType} from "@/api/crmedical/group/group";
import Select from '../../../../../packages/config/select.vue';
  
export default {
  components: {
    'select-time': selectTime
  },
    data(){
        return{
          handleIdList:[],//处理人
            standardList:[],
            selectTimeFlag:false,
            tempProjectId:'',
        inspectLineList:[],
        inspectForm:{},
        selectedTime:[],
        dialogInspectLineCreateBoxVisible:false,
            addInspectPlanForm:{
                inspectCycleType:1,
                detailDateList:["1"],
                projectId:'',
                name:'',
                dateRange:'',
                timeQuantum:'',
                remark:'',
                planInspectManId:'',
            },
            addInspectPlanFormRules:[
                'inspectCycleType','detailDateList','projectId','name','dateRange','timeQuantum','remark'
            ],
            formLabelKey:{
                inspectCycleType:'巡检周期类型',
                detailDateList:'具体时间',
                projectId:'项目名称',
                name:'计划名称',
                dateRange:'计划日期',
                timeQuantum:'时间段',
                remark:'巡检说明',
                inspectBeginTime:'巡视开始时间',
                inspectCycle:'巡检天数',
                intervalTime:'周期休息天数（天）'
            },
            formElement:{
                inspectCycleType:'selecat',
                detailDateList:'checkbox',
                projectId:'input',
                name:'input',
                dateRange:'input',
                timeQuantum:'时间段',
                remark:'巡检说明',
            },
            inspectCycleType:1,
            deviceList:[],
            projectList:[],
        }
    },
    created(){
        getProjectList().then((res)=>{
                    console.log(res);
                    this.projectList = res.data;
                    this.addInspectPlanForm.projectId = res.data[0].id;
                    this.tempProjectId = res.data[0].id;
                    this.getGroupListByModuleType(this.addInspectPlanForm.projectId);
                    getDeviceList({projectId:this.tempProjectId}).then((res)=>{
                      console.log(res);
                      res.data.forEach((ele,index)=>{
                        ele.name = ele.name+'-'+ele.code
                      });
                      this.deviceList = res.data;
                    });
                    // getDeviceList({projectId:this.addInspectPlanForm.projectId}).then((res)=>{
                    //   console.log(res);
                    //   this.deviceList = res.data;
                    // });
                    // this.addGroupForm.projectId = this.projectList[0].id;
                });
    },
    mounted(){
        // setTimeout(()=>{
            this.selectTimeFlag = true;
        // },1000)
    },
    methods:{
        cancelInspectAddFrom(){
            this.$emit('closeAddForm');
        },
        submitInspectAddFrom(){
            if(this.addInspectPlanForm.dateRange){
                this.addInspectPlanForm.planBeginTime = this.addInspectPlanForm.dateRange[0]
                this.addInspectPlanForm.planEndTime = this.addInspectPlanForm.dateRange[1]
            }
            
            if(this.addInspectPlanForm.detailDateList){
                this.addInspectPlanForm.detailDate = this.addInspectPlanForm.detailDateList.join(',');
            }
            if(this.inspectLineList){
              this.addInspectPlanForm.devices = [];
              this.inspectLineList.forEach((e,i)=>{
                this.addInspectPlanForm.devices.push({
                  standardIds:e.standardIds.join(','),
                  deviceId:e.deviceId
                })
              });
            }
            // console.log(this.selectedTime);
            console.log(this.addInspectPlanForm);
            console.log(this.inspectLineList);
            console.log(Object.keys(this.addInspectPlanForm));
            console.log(Object.values(this.addInspectPlanForm));
            let validkeysList = this.addInspectPlanFormRules;
            let valuesList = Object.values(this.addInspectPlanForm)
            let validBlock = this.commonValid(validkeysList,valuesList);
            let validBlock_ = false;
            let _validBlock_ = false;
              let re = /^[0-9]+$/ ;
            if(this.addInspectPlanForm.inspectCycleType == 4){
                validBlock_ = this.commonValid(['inspectBeginTime','inspectCycle','intervalTime'],
                [this.addInspectPlanForm.inspectBeginTime,this.addInspectPlanForm.inspectCycle,this.addInspectPlanForm.intervalTime],
                re
              );
            }
            if(this.addInspectPlanForm.inspectCycleType == 2 || this.addInspectPlanForm.inspectCycleType == 3 ){
                if(this.addInspectPlanForm.detailDateList.length==0){
                    _validBlock_ = true;
                    this.$message.error(`"具体时间"不能为空!`);
                    return;
                }
                // validBlock_ = this.commonValid(['inspectBeginTime','inspectCycle','intervalTime'],[this.addInspectPlanForm.inspectBeginTime,this.addInspectPlanForm.inspectCycle,this.addInspectPlanForm.intervalTime]);
            }
            if(this.inspectLineList.length==0){
                    this.$message.error(`"巡检路线"不能为空!`);
                    return;
            }
            if(validBlock || validBlock_){
                return;
            }
            if(this.addInspectPlanForm.inspectCycleType == 4){
                if(!re.test(this.addInspectPlanForm.inspectCycle)){
                  this.$message.error('"巡检天数"格式错误!');
                  return;
                }
                if(!re.test(this.addInspectPlanForm.intervalTime)){
                  this.$message.error('"周期休息天数（天）"格式错误!');
                  return;
                }
            }
            saveInspectPlan(this.addInspectPlanForm).then((res)=>{
                console.log(res);
                this.$emit('closeAddForm');
            });

        },
        commonValid(keysList,valuesList,re){
            let validBlock = false;
            // let tempValidItem = 
            console.log(keysList);
            keysList.forEach((ele,index)=>{
                this.clearValidStyle(ele)
            });
            keysList.forEach((ele,index)=>{
                // this.clearValidStyle(ele)
                if(!valuesList[index]){
                    validBlock = true;
                    this.setValidStyle(ele,this.formLabelKey,re);
                }
            });
            return validBlock;

        },
        setValidStyle(ele,formLabelKey){
            // setTimeout(()=>{
                if(ele==='timeQuantum'||ele==='detailDate'||ele==='detailDateList'||ele==='devices'){

                }else if(ele==="remark"){
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('textarea'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('textarea').style.border = '1px solid red';
                }else{
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('input'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('input').style.border = '1px solid red';

                }
            setTimeout(()=>{
                this.$message.error(`"${this.formLabelKey[ele]}"不能为空!`);
            },600);
        },
        clearValidStyle(ele){
            console.log('clearValidStyle==>'+ele);
            // setTimeout(()=>{
                if(ele==='timeQuantum'||ele==='detailDate'||ele==='detailDateList'||ele==='devices'){

                }else if(ele==="remark"){
                    
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('textarea'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('textarea').style.border = '';
                }else{
                    // if(inspectCycleType){
                        console.log("ele==>",ele);
                        console.log(document.querySelector(`div[valid=${ele}]`).querySelector('input'));
                        document.querySelector(`div[valid=${ele}]`).querySelector('input').style.border = '';
                    // }

                }
                // this.$message.error(`"${this.formLabelKey[ele]}"不能为空!`);
            // },500);
        },
        handleProjectIdChange(val){
            this.tempProjectId = val;
            this.addInspectPlanForm.planInspectManId = ''
            this.getGroupListByModuleType(val);
            getDeviceList({projectId:val}).then((res)=>{
              console.log(res);
                      res.data.forEach((ele,index)=>{
                        ele.name = ele.name+'-'+ele.code
                      });
              this.deviceList = res.data;
            });
        },
        planInspectManIdChange(val){
          this.addInspectPlanForm.planInspectManId = val
        },
      getGroupListByModuleType(projectId){
        getGroupListByModuleType({projectId:projectId,moduleType:9}).then(res=>{
          res.data.forEach(item=>{
            item.label = item.realNameAndPhone;
            item.value = item.userId;
          })
          this.handleIdList = res.data;
        })
      },
      handleDeviceChange(val){
        
        // getDeviceList().then((res)=>{
        //   console.log(res);
        //   this.deviceList = res.data;
        // });
        this.inspectForm.standardIds = [];
        this.deviceList.forEach((ele,index)=>{
          if(ele.id === val){
            this.inspectForm.deviceName = ele.name;
          }
        });
        getStandardList({deviceId:val}).then((res)=>{
            // console.log(res);
            this.standardList = res.data
        });
      },
      
      handleStandardChange(val){
        console.log('8888');
        this.inspectForm.standardNames = [];
        console.log(this.inspectForm.standardIds,this.standardList);
        this.standardList.forEach((ele,index)=>{
          this.inspectForm.standardIds.forEach((el,i)=>{
            if(ele.id === el){
              this.inspectForm.standardNames.push(ele.name);
            }
          });
        });
        console.log(this.inspectForm.standardNames);
        // getStandardList({deviceId:val}).then((res)=>{
        //     // console.log(res);
        //     this.standardList = res.data
        // });
      },
      addInspectLine(){
        // getDeviceList({projectId:this.tempProjectId}).then((res)=>{
        //   console.log(res);
        //   this.deviceList = res.data;
        // });
          // this.inspectForm.deviceId = '';
          this.inspectForm = Object.assign({},this.inspectForm,{deviceId:'',standardIds:[]});
        this.dialogInspectLineCreateBoxVisible = true;
      },
      saveInspectLineHandler(){
        let selectBlock = false;
        if(!this.inspectForm.deviceId){
          this.$message.error('请选择巡检设备！');
          return;
        }
        if(!this.inspectForm.standardIds||this.inspectForm.standardIds.length==0){
          this.$message.error('请选择巡检标准！');
          return;
        }
        if(this.inspectLineList&&this.inspectLineList.length>0){
          this.inspectLineList.forEach((ele,index)=>{
            if(this.inspectForm.deviceId === ele.deviceId){
              selectBlock = true;
            }
          });
        }
        if(selectBlock){
          this.$message.error('巡检设备有重复！');
          return;
        }
        this.inspectLineList.push({
            deviceName:this.inspectForm.deviceName,
            deviceId:this.inspectForm.deviceId,
            standardIds:this.inspectForm.standardIds,
            standardNames:this.inspectForm.standardNames?this.inspectForm.standardNames.join(','):'',
            });
        this.dialogInspectLineCreateBoxVisible = false;
      },
      handleCycleTypeChange(val){
        this.addInspectPlanForm.detailDate = [];
        this.addInspectPlanForm.inspectCycleType = val;
      },
        // 获得时间选择器传来的值
        getTime(time) {
        // this.inspectplanAddForm.timeQuantum = time;
            console.log(time);
            if(time){
                let timeList = [];
                time.forEach((ele,index)=>{
                    timeList.push(ele.time);
                })
                this.addInspectPlanForm.timeQuantum = timeList.join(',');
            }
        },
        deleteHandler(row){
            this.inspectLineList.forEach((ele,index)=>{
                if(row.deviceId===ele.deviceId){
                    this.inspectLineList.splice(index,1);
                }
            });
        },
    }
}
</script>

<style>

</style>